<template>
  <VTDropdownPill
    :disable-save-button="!isDiscountInPercentValid()"
    :is-enabled="!disabled"
    @confirm="saveChanges"
    @clear="reset"
    @on-click-outside="discardChanges"
  >
    <template #dropDownHeader>
      <VTPill label="Discount in percent">
        <template #values>
          <div :class="$style.wrapper">
            <div>
              <div :class="$style.row">
                <div :class="[$style.valuesContainer, $style.timeText]">
                  <VdIcon store="fas" name="fa-percent" size="medium" color="#909298" :class="$style.percentIcon" />
                  {{ props.modelValue }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </VTPill>
    </template>
    <template #dropdown-content>
      <div :class="$style.dropdownContainer">
        <p>Discount in percent</p>

        <IconField icon-position="left">
          <VdIcon store="fas" name="fa-percent" size="medium" />
          <InputNumber
            v-model="discountInPercent"
            :input-class="$style.inputStyle"
            mode="decimal"
            locale="en-US"
            :max="100"
            :min="0"
            :min-fraction-digits="0"
            :max-fraction-digits="0"
          />
        </IconField>
        <div v-if="!isDiscountInPercentValid()">
          <p :class="$style.invalidText">Please enter a valid number between 0 and 100.</p>
        </div>
      </div>
    </template>
  </VTDropdownPill>
</template>

<script setup lang="ts">
import VTDropdownPill from "@/components/VTDropdownPill";
import VTPill from "@/components/VTPill";
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import IconField from "primevue/iconfield";
import InputNumber from "primevue/inputnumber";
import type { Ref } from "vue";
import { ref } from "vue";

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["update"]);
const discountInPercent: Ref<number> = ref(props.modelValue);
const saveChanges = () => {
  emit("update", discountInPercent.value);
};
const reset = () => {
  emit("update", 0);
  discountInPercent.value = 0;
};
const discardChanges = () => {
  discountInPercent.value = props.modelValue;
};
const isDiscountInPercentValid = () => {
  if (discountInPercent.value === null) {
    return false;
  }
  return discountInPercent.value <= 100 && discountInPercent.value >= 0;
};
</script>
<style module lang="scss">
.wrapper {
  display: flex;
  flex-direction: row;
  overflow-x: hidden;
  align-items: center;
  gap: 8px;
}
.dropdownContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.row {
  display: flex;
  position: relative;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
}
.valuesContainer {
  display: flex;
  gap: 8px;
  align-items: center;
}
.timeText {
  font-weight: 700;
  font-size: 14px;
}

.invalidText {
  color: var(--vd-color-error);
  margin: 0;
  padding: 0;
}
.inputStyle {
  padding-left: 2.2rem;
}
</style>

<style scoped lang="scss">
:deep(.p-iconfield svg) {
  position: absolute;
  top: 50%;
  margin-top: -0.5rem;
  margin-left: 0.75rem;
  z-index: 1000;
}
</style>
